import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';

/**
 * 콘텐츠 작품 커서 인덱스 조회
 *
 * Origin: pageNicolasApi.getContentHomeProductCursorIndex
 * API: GET /api/v1/content/product/cursor_index
 */
export async function getContentProductCursorIndex(
  {
    seriesId,
    sortType,
  }: {
    seriesId: number;
    sortType?: string;
  },
  options?: FetcherOptions
): Promise<ApiResultVo & {result: {last_cursor_index: number}}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/content/product/cursor_index',
    {
      method: 'GET',
      params: {
        series_id: seriesId,
        ...(sortType && {sort_type: sortType}),
      },
    },
    options
  );
  return response.data;
}
